import { defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin(async () => {
  await import('@formatjs/intl-durationformat/polyfill.js')
})
